<template>
	<AjaxTable
		ref="AjaxTable"
		v-bind="this.$attrs"
		v-on="this.$listeners"
	>
		<template #cell(actions)="row">
			<div class="d-flex justify-content-center">
				<b-button @click="(event) => resView(row.item,row.index,event)" type="button" size="sm" class="mr-1" variant="info">
					<md-icon icon="visibility"></md-icon>
				</b-button>
			</div>
		</template>
		<template #cell(clientName)="row">
			{{row.item.reservation.client.firstName}} {{row.item.reservation.client.lastName}}
		</template>
		<template #cell(clientPhone)="row">
			{{row.item.reservation.client.phone}}
		</template>
		<template #cell(clientEmail)="row">
			{{row.item.reservation.client.email}}
		</template>
		<template #cell(reservationId)="row">
				<md-icon icon="home" v-if="row.item.reservation.operatedBy == 'supplier'"/><ScIcon v-else />{{row.item.reservationId}}
		</template>
		<template #cell(pickupDatetime)="row">
			{{row.item.pickupDatetime | moment('D MMM YYYY HH:mm')}}
		</template>
		<template #cell(flightDatetime)="row">
			{{row.item.flightDatetime}} / {{row.item.flightNumber}}
		</template>
		<template #cell(pickup)="row">
			{{row.item.pickup.name}}
		</template>
		<template #cell(dropoff)="row">
			{{row.item.dropoff.name}}
		</template>
		<template #cell(serviceType)="row">
			{{row.item.supplierServiceType.name}}
		</template>
		<template #cell(trackingStatus)="row">
			{{trackingStatusLabels[row.item.trackingStatus]}}
		</template>
		<template #cell(salesChannel)="row">
			<div v-if="row.item.reservation.operatedBy == 'supplier'">
				{{ row.item.supplierSalesChannel }}
			</div>
			<div v-else>
				{{row.item.salesChannel ? row.item.salesChannel.name : ''}}
			</div>
		</template>
		<template #cell(status)="row">
			{{statusLabels[row.item.status]}}
		</template>
		<template #cell(transportUnit)="row">
			<span v-if="row.item.transportUnit !== null">
				{{row.item.transportUnit.title}}
			</span>
			<span v-else>N/A</span>
		</template>
		<template #cell(userDriver)="row">
			<span v-if="row.item.userDriver !== null">
				{{row.item.userDriver.firstName}} {{row.item.userDriver.lastName}}
			</span>
			<span v-else>N/A</span>
		</template>
		<template #cell(passengers)="row">
			{{$t('bookings.adults')}}: {{row.item.reservation.adults}}<br/>
			{{$t('bookings.kids')}}: {{row.item.reservation.children}}<br/>
			{{$t('bookings.infants')}}: {{row.item.reservation.infants}}
		</template>
		<template #cell(supplierStatus)="row">
			<b-badge :variant="iconSupplierConfirmation(row.item.supplierConfirmation).class">
				<md-icon  :icon="iconSupplierConfirmation(row.item.supplierConfirmation).icon"/>
			</b-badge>
		</template>
	</AjaxTable>
</template>

<script>
// @ is an alias to /src
import AjaxTable from '@/components/helpers/AjaxTable.vue'

export default {
	components: {
		AjaxTable
	},
	props : {
		resView : {
			type: Function,
			required: true
		}
	},
	methods : {
		iconSupplierConfirmation(status){
			let icon = "";
			let classe = "";
			switch(status){
				case "pending":
					icon   = 'warning'
					classe = 'warning'
					break
				case "confirmed":
					icon = 'check_circle';
					classe = 'success';
					break;
				case "rejected":
					icon   = 'dangerous'
					classe = 'danger'
					break;
			}
			return {icon:icon,class:classe};
		},
		getChildtableRef(){
			return this.$refs.AjaxTable
		}
	},
	computed : {
		trackingStatusLabels(){
			let vars = this.$root.auxVars.transportServiceTrackingStatusOpts
			let opts = {}
			for (let i = 0; i < vars.length; i++) {
				opts[vars[i].value] = this.$t(`bookings.trackingStatusOpts.${vars[i].value}`)
			}
			return opts
		},
	}
}
</script>
